module.exports = __webpack_public_path__ + "static/occasion-ig-23374495d698712937713debd5137b41.mp4";